export default __webpack_public_path__ + "eacf60938ce2761ac75ff31fa8bda7e7.png";